// Copyright (C) 2021 Bystronic Laser AG

import { KpiWidgetData } from '@/models/Charts/chartsData';
import { isEmpty } from '@/utils/misc';
import { createPaletteByLightness } from '@/utils/color';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';

/**
 * Information about the trend of a KPI.
 *
 * Used to calculate the trend between periods of time and to show additional
 * data for the user to better understand it.
 */
export interface TrendData {
  currentValue: number;
  previousValue: number;
  chartType: 'pie' | 'bar';
  timeSpan: FilterTimeSpanEnum;

  // These are defined for type 'bar'. Null if there's no data for the period.
  currentValueDeviceName?: string | null;
  currentValueDateTime?: Date | null;
  previousValueDeviceName?: string | null;
  previousValueDateTime?: Date | null;
}

/** Returns the trend data from pie widget's data, null if there's no data. */
export function getTrendDataFromPieWidgetData(
  data: KpiWidgetData[] | null | undefined,
  timeSpan: FilterTimeSpanEnum,
): TrendData | null {
  if (isEmpty(data)) {
    return null;
  }

  return {
    currentValue: getTotalAmount(data!, 'currentValue'),
    previousValue: getTotalAmount(data!, 'previousValue'),
    timeSpan,
    chartType: 'pie',
  };
}

function getTotalAmount(data: any[], valueField: string): number {
  return data
    .map((dataEntry) => dataEntry[valueField])
    .reduce((total, value) => total + value, 0);
}

export function generatePalette(
  cssBaseColor: string,
  numberOfColors: number,
): string[] {
  return createPaletteByLightness(
    cssBaseColor,
    numberOfColors,
    -0.35,
    0.35,
  ).reverse();
}
